<app-modal-dialog
    [bodyTemplate]="bodyTemplate"
    [showCloseButton]="false"
    [footerTemplate]="footerTemplate">
    <ng-template #bodyTemplate>
        <div class="container-fluid">
            <h5 class="dialog">
                <mat-icon
                    class="icon-color-primary me-2"
                    fontSet="material-symbols-outlined"
                    >swap_horiz</mat-icon
                >
                {{
                    'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.TAB-LABEL'
                        | translate
                }}
            </h5>
            @if (
                consignorChain?.length &&
                carrierChain?.length &&
                consigneeChain?.length
            ) {
                <div
                    class="tw-grid tw-w-full tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8 tw-p-4 xl:tw-flex xl:tw-justify-center">
                    <!-- CONSIGNOR -->
                    <div>
                        <div class="workflow-column">
                            <h3 class="tw-flex tw-items-center">
                                <mat-icon
                                    class="tw-mr-3"
                                    fontSet="material-symbols-outlined"
                                    >{{ getIconName('direction') }}</mat-icon
                                >
                                {{
                                    'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CONSIGNOR.TITLE'
                                        | translate
                                }}
                            </h3>
                            <div class="rounded-frame">
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CONSIGNOR.PLACEHOLDER'
                                            | translate
                                    }}</mat-label>
                                    <input
                                        aria-label="searchSupplyChain"
                                        [(ngModel)]="consignorSearchTerm"
                                        type="text"
                                        matInput
                                        #consignorInput />
                                    @if (!consignorInput.value) {
                                        <mat-icon
                                            matPrefix
                                            fontSet="material-symbols-outlined"
                                            >filter_list</mat-icon
                                        >
                                    }
                                    @if (consignorInput.value) {
                                        <button
                                            class="light"
                                            mat-icon-button
                                            matSuffix
                                            matTooltip="{{
                                                'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.TOOLTIP-DELETE-ICON'
                                                    | translate
                                            }}"
                                            aria-label="Clear"
                                            (click)="
                                                consignorInput.value = '';
                                                clearConsignorSearch()
                                            ">
                                            <mat-icon
                                                fontSet="material-symbols-outlined"
                                                >close</mat-icon
                                            >
                                        </button>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CONSIGNOR.TITLE'
                                            | translate
                                    }}</mat-label>
                                    <input
                                        type="text"
                                        matInput
                                        id="consignor"
                                        [(ngModel)]="consignorValue"
                                        disabled />
                                </mat-form-field>
                                <!-- Virtual Scroll for Consignor -->
                                <cdk-virtual-scroll-viewport
                                    itemSize="40"
                                    style="height: 300px">
                                    <mat-list-item
                                        class="mat-mdc-list-item-interactive"
                                        aria-label="supplyChainElements"
                                        (click)="onConsignorClick(item)"
                                        style="height: 40px"
                                        *cdkVirtualFor="
                                            let item of consignorChain
                                                | filterByName
                                                    : consignorSearchTerm;
                                            let i = index
                                        ">
                                        <span
                                            class="has-pointer item item-{{
                                                i
                                            }}"
                                            >{{ item.fullSiteName }}</span
                                        >
                                        <div class="tw-pb-1"></div>
                                    </mat-list-item>
                                </cdk-virtual-scroll-viewport>
                                <!-- No results message outside viewport -->
                                @if (
                                    (
                                        consignorChain
                                        | filterByName: consignorSearchTerm
                                    )?.length === 0 &&
                                    consignorChain?.length > 0 &&
                                    consignorSearchTerm
                                ) {
                                    <div
                                        class="tw-p-2 tw-text-gray-500 tw-text-center">
                                        {{
                                            'GENERAL.NO_RESULTS_FOUND'
                                                | translate
                                        }}
                                    </div>
                                }
                            </div>
                        </div>
                        @if (consignorSelected) {
                            <div
                                class="tw-mt-2 tw-text-green-600 tw-flex tw-items-center tw-justify-center">
                                <mat-icon
                                    class="tw-mr-1"
                                    fontSet="material-symbols-outlined"
                                    >check_circle</mat-icon
                                >
                                {{ selectedActors.consignor?.name }}
                            </div>
                        }
                    </div>
                    <!-- CARRIER -->
                    <div>
                        <div class="workflow-column">
                            <h3 class="tw-flex tw-items-center">
                                <mat-icon
                                    class="tw-mr-3"
                                    fontSet="material-symbols-outlined"
                                    >{{ getIconName('truck') }}</mat-icon
                                >
                                {{
                                    'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CARRIER.TITLE'
                                        | translate
                                }}
                            </h3>
                            <div class="rounded-frame">
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CARRIER.PLACEHOLDER'
                                            | translate
                                    }}</mat-label>
                                    <input
                                        aria-label="searchSupplyChain"
                                        [(ngModel)]="carrierSearchTerm"
                                        type="text"
                                        matInput
                                        #carrierInput />
                                    @if (!carrierInput.value) {
                                        <mat-icon
                                            matPrefix
                                            fontSet="material-symbols-outlined"
                                            >filter_list</mat-icon
                                        >
                                    }
                                    @if (carrierInput.value) {
                                        <button
                                            class="light"
                                            mat-icon-button
                                            matSuffix
                                            matTooltip="{{
                                                'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.TOOLTIP-DELETE-ICON'
                                                    | translate
                                            }}"
                                            aria-label="Clear"
                                            (click)="
                                                carrierInput.value = '';
                                                clearCarrierSearch()
                                            ">
                                            <mat-icon
                                                fontSet="material-symbols-outlined"
                                                >close</mat-icon
                                            >
                                        </button>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CARRIER.TITLE'
                                            | translate
                                    }}</mat-label>
                                    <input
                                        type="text"
                                        matInput
                                        id="carrier"
                                        [(ngModel)]="carrierValue"
                                        disabled />
                                </mat-form-field>
                                <!-- Virtual Scroll for Carrier -->
                                <cdk-virtual-scroll-viewport
                                    itemSize="40"
                                    style="height: 300px">
                                    <mat-list-item
                                        class="mat-mdc-list-item-interactive"
                                        aria-label="supplyChainElements"
                                        (click)="onCarrierClick(item)"
                                        style="height: 40px"
                                        *cdkVirtualFor="
                                            let item of carrierChain
                                                | filterByName
                                                    : carrierSearchTerm;
                                            let i = index
                                        ">
                                        <span
                                            class="has-pointer item item-{{
                                                i
                                            }}"
                                            >{{ item.fullSiteName }}</span
                                        >
                                        <div class="tw-pb-1"></div>
                                    </mat-list-item>
                                </cdk-virtual-scroll-viewport>
                                <!-- No results message outside viewport -->
                                @if (
                                    (
                                        carrierChain
                                        | filterByName: carrierSearchTerm
                                    )?.length === 0 &&
                                    carrierChain?.length > 0 &&
                                    carrierSearchTerm
                                ) {
                                    <div
                                        class="tw-p-2 tw-text-gray-500 tw-text-center">
                                        {{
                                            'GENERAL.NO_RESULTS_FOUND'
                                                | translate
                                        }}
                                    </div>
                                }
                            </div>
                        </div>
                        @if (carrierSelected) {
                            <div
                                class="tw-mt-2 tw-text-green-600 tw-flex tw-items-center tw-justify-center">
                                <mat-icon
                                    class="tw-mr-1"
                                    fontSet="material-symbols-outlined"
                                    >check_circle</mat-icon
                                >
                                {{ selectedActors.carrier?.name }}
                            </div>
                        }
                    </div>
                    <!-- CONSIGNEE -->
                    <div>
                        <div class="workflow-column">
                            <h3 class="tw-flex tw-items-center">
                                <mat-icon
                                    class="tw-mr-3"
                                    fontSet="material-symbols-outlined"
                                    >{{
                                        getIconName('folder_checked')
                                    }}</mat-icon
                                >
                                {{
                                    'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CONSIGNEE.TITLE'
                                        | translate
                                }}
                            </h3>
                            <div class="rounded-frame">
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CONSIGNEE.PLACEHOLDER'
                                            | translate
                                    }}</mat-label>
                                    <input
                                        aria-label="searchSupplyChain"
                                        [(ngModel)]="consigneeSearchTerm"
                                        type="text"
                                        matInput
                                        #consigneeInput />
                                    @if (!consigneeInput.value) {
                                        <mat-icon
                                            matPrefix
                                            fontSet="material-symbols-outlined"
                                            >filter_list</mat-icon
                                        >
                                    }
                                    @if (consigneeInput.value) {
                                        <button
                                            class="light"
                                            mat-icon-button
                                            matSuffix
                                            matTooltip="{{
                                                'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.TOOLTIP-DELETE-ICON'
                                                    | translate
                                            }}"
                                            aria-label="Clear"
                                            (click)="
                                                consigneeInput.value = '';
                                                clearConsigneeSearch()
                                            ">
                                            <mat-icon
                                                fontSet="material-symbols-outlined"
                                                >close</mat-icon
                                            >
                                        </button>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.CONSIGNEE.TITLE'
                                            | translate
                                    }}</mat-label>
                                    <input
                                        type="text"
                                        matInput
                                        id="consignee"
                                        [(ngModel)]="consigneeValue"
                                        disabled />
                                </mat-form-field>
                                <!-- Virtual Scroll for Consignee -->
                                <cdk-virtual-scroll-viewport
                                    itemSize="40"
                                    style="height: 300px">
                                    <mat-list-item
                                        class="mat-mdc-list-item-interactive"
                                        aria-label="supplyChainElements"
                                        (click)="onConsigneeClick(item)"
                                        style="height: 40px"
                                        *cdkVirtualFor="
                                            let item of consigneeChain
                                                | filterByName
                                                    : consigneeSearchTerm;
                                            let i = index
                                        ">
                                        <span
                                            class="has-pointer item item-{{
                                                i
                                            }}"
                                            >{{ item.fullSiteName }}</span
                                        >
                                        <div class="tw-pb-1"></div>
                                    </mat-list-item>
                                </cdk-virtual-scroll-viewport>
                                <!-- No results message outside viewport -->
                                @if (
                                    (
                                        consigneeChain
                                        | filterByName: consigneeSearchTerm
                                    )?.length === 0 &&
                                    consigneeChain?.length > 0 &&
                                    consigneeSearchTerm
                                ) {
                                    <div
                                        class="tw-p-2 tw-text-gray-500 tw-text-center">
                                        {{
                                            'GENERAL.NO_RESULTS_FOUND'
                                                | translate
                                        }}
                                    </div>
                                }
                            </div>
                        </div>
                        @if (consigneeSelected) {
                            <div
                                class="tw-mt-2 tw-text-green-600 tw-flex tw-items-center tw-justify-center">
                                <mat-icon
                                    class="tw-mr-1"
                                    fontSet="material-symbols-outlined"
                                    >check_circle</mat-icon
                                >
                                {{ selectedActors.consignee?.name }}
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- Error message if data is missing -->
            @if (
                !consignorChain?.length ||
                !carrierChain?.length ||
                !consigneeChain?.length
            ) {
                <div
                    class="tw-p-4 tw-mt-4 tw-bg-red-50 tw-text-red-600 tw-rounded-md tw-text-center">
                    {{
                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.ERROR.NO_DATA'
                            | translate
                    }}
                </div>
            }
        </div>
    </ng-template>

    <!-- Footer remains the same -->
    <ng-template #footerTemplate>
        <button
            tabindex="-1"
            type="button"
            mat-stroked-button
            (click)="cancel()">
            {{ 'CONFIRMATION-DIALOG.BUTTON-BACK' | translate }}
        </button>
        <button
            id="button-chain-confirm"
            tabindex="1"
            type="button"
            mat-flat-button
            color="primary"
            [disabled]="!isSelectionComplete()"
            (click)="confirm()">
            {{ 'CONFIRMATION-DIALOG.BUTTON-OKAY' | translate }}
        </button>
    </ng-template>
</app-modal-dialog>
